import React from "react";
import htmlicon from "./images/htmlicon.svg";
import cssicon from "./images/cssicon.svg";
import apiicon from "./images/apiicon.svg";
import giticon from "./images/giticon.svg";
import reacticon from "./images/reacticon.svg";
import javascripticon from "./images/javascripticon.svg";
import vscodeicon from "./images/vscodeicon.svg";
import tailwindicon from "./images/tailwindicon.svg";
import sassicon from "./images/sassicon.svg";
import bootstrapicon from "./images/bootstrapicon.svg";
import npmicon from "./images/npmicon.svg";
import jqueryicon from "./images/jqueryicon.svg";
import { useContext } from "react";
import { defaultLang } from "./LanguageContext";
import profilepic from "./images/profilepic.jpg";
const skillImg = [
  {
    img: htmlicon,
    link: "https://www.google.com/search?q=what+is+html+&rlz=1C1ONGR_itIT1028IT1028&sxsrf=ALiCzsZBg7cS5t3x566s8hFxkwkUtkRkyQ%3A1666287844253&ei=5IhRY8_9DoOllwTS1YuADw&ved=0ahUKEwjP_7L4re_6AhWD0oUKHdLqAvAQ4dUDCA8&uact=5&oq=what+is+html+&gs_lp=Egxnd3Mtd2l6LXNlcnC4AQP4AQEaAhgDMgcQIxjqAhgnMgcQIxjqAhgnMgcQIxjqAhgnMgcQIxjqAhgnMgcQIxjqAhgnMgcQIxjqAhgnMgcQIxjqAhgnMgcQIxjqAhgnMgcQIxjqAhgnMhAQLhjHARjRAxjqAhgnGIsDwgIEECMYJ8ICBBAAGEOoAgpI6EZQ-xVYlkVwBXgByAEAkAEBmAHRCqABsCiqAQc1LTEuMS4z4gMEIE0YAeIDBCBBGADiAwQgRhgAiAYB&sclient=gws-wiz-serp",
  },
  { img: cssicon, link: "https://developer.mozilla.org/en-US/docs/Web/CSS" },
  {
    img: javascripticon,
    link: "https://www.google.com/search?q=javascript&rlz=1C1ONGR_itIT1028IT1028&oq=javascript+&aqs=chrome..69i57.3910j0j7&sourceid=chrome&ie=UTF-8",
  },
  { img: vscodeicon, link: "https://code.visualstudio.com/" },
  {
    img: tailwindicon,
    link: "https://www.google.com/search?q=tailwind+css&rlz=1C1ONGR_itIT1028IT1028&oq=tailwind+css&aqs=chrome..69i57j0i271l3j69i60j69i61j69i60.2749j0j7&sourceid=chrome&ie=UTF-8",
  },
  {
    img: reacticon,
    link: "https://www.google.com/search?q=react&rlz=1C1ONGR_itIT1028IT1028&oq=react&aqs=chrome..69i57j0i271l3j69i60j69i61l2j69i60.13391j0j7&sourceid=chrome&ie=UTF-8",
  },
  {
    img: apiicon,
    link: "https://www.techtarget.com/searchapparchitecture/definition/application-program-interface-API",
  },
  {
    img: giticon,
    link: "https://www.google.com/search?q=git&rlz=1C1ONGR_itIT1028IT1028&oq=git&aqs=chrome..69i57j69i59j0i271l2j69i60l4.1995j0j7&sourceid=chrome&ie=UTF-8",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/0/07/Angular_Logo_SVG.svg",
    link: "https://angular.dev/",
  },
  {
    img: bootstrapicon,
    link: "https://getbootstrap.com/",
  },
  {
    img: npmicon,
    link: "https://www.npmjs.com/",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
    link: "https://en.wikipedia.org/wiki/Node.js",
  },
];
function About() {
  const { lang } = useContext(defaultLang);
  return (
    <section className='pb-10'>
      <h1 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-5xl pb-6 mt-28 font-bold tracking-wider '>
        {lang === "Eng" ? "About Me" : "Informazioni Personali"}
      </h1>
      <div className='w-[30px] h-[8px] bg-[#9499ff] rounded-[10px] mx-auto'></div>
      <h2 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-xl mt-5 mb-10 font-semibold tracking-wider'>
        {lang === "Eng" ? "Hi there, I'm Daniel" : "Ciao, sono Daniel"}
      </h2>

      <div className='flex justify-center items-center hover:scale-[.9] transition-all duration-300'>
        <div className='avatar'>
          <img className='' src={profilepic} alt="Daniel's profile pic" />
        </div>
      </div>

      <div className='  text-center text-[#E3E3E3]   leading-7 dark:text-[#1E1E1E] mt-10 mx-12  md:mx-26 lg:mx-36 xl:mx-[20rem] lg:text-lg lg:leading-[2rem] '>
        <p>
          {lang === "Eng" ? (
            <>
              {" "}
              A <span className='text-[#9499ff]'>skilled web developer</span>
              &nbsp; with a passion for creating dynamic, responsive, and
              user-friendly websites. With over 3+ years of experience, I have
              honed my skills in &nbsp;
            </>
          ) : (
            <>
              {" "}
              Uno <span className='text-[#9499ff]'>sviluppatore web</span>&nbsp;
              con la passione per la creazione di contenuti dinamici, reattivi e
              facili da usare siti web. Con oltre 3+ anni di esperienza, ho
              affinato le mie capacità in &nbsp;
            </>
          )}

          <span className='text-[#d84924]'>
            <a
              className='hover:underline'
              target='_blank'
              rel='noreferrer'
              href='https://www.freecodecamp.org/news/html-css-and-javascript-explained-for-beginners/#:~:text=As%20a%20web%20developer%2C%20the,just%20a%20design%20language%2C%20though.'>
              HTML, &nbsp;
            </a>
          </span>
          <span className='text-[#6794ff]'>
            <a
              className='hover:underline'
              target='_blank'
              rel='noreferrer'
              href='https://www.freecodecamp.org/news/html-css-and-javascript-explained-for-beginners/#:~:text=As%20a%20web%20developer%2C%20the,just%20a%20design%20language%2C%20though.'>
              CSS, &nbsp;
            </a>
          </span>
          <span className='text-[#e4d04b]'>
            <a
              className='hover:underline'
              target='_blank'
              rel='noreferrer'
              href='https://www.freecodecamp.org/news/html-css-and-javascript-explained-for-beginners/#:~:text=As%20a%20web%20developer%2C%20the,just%20a%20design%20language%2C%20though.'>
              Javascript &nbsp;
            </a>
          </span>
          {lang === "Eng" ? (
            <>
              {" "}
              and other libraries and frameworks, allowing me to bring{" "}
              <span className='text-[#9499ff]'>complex designs</span>&nbsp; to
              life. I am constantly seeking new challenges and opportunities to
              expand my knowledge and skill set. I take pride in creating
              websites that not only look great, but also provide a{" "}
              <span className='text-[#9499ff]'>seamless user-experience.</span>
              While I primarily develop websites without frameworks or using
              React, Currently, I am learning{" "}
              <span className='text-red-500'>Angular</span> to further enhance
              my development capabilities.
            </>
          ) : (
            <>
              e altre librerie e framework, permettendomi di creare{" "}
              <span className='text-[#9499ff]'>progetti complessi</span>&nbsp;
              Sono costantemente alla ricerca di nuove sfide e opportunità per
              espandere il mio insieme di conoscenze e abilità. Sono orgoglioso
              di creare siti Web che non solo hanno un bell'aspetto, ma
              forniscono anche un'
              <span className='text-[#9499ff]'>esperienza utente fluida.</span>
              &nbsp; Anche se sviluppo principalmente siti web senza framework o
              utilizzando React, Attualmente sto imparando{" "}
              <span className='text-red-500'>Angular</span> per migliorare
              ulteriormente le mie capacità di sviluppo.
            </>
          )}
        </p>
      </div>

      <div className='grid justify-center mx-3 pt-5'>
        <h1 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-5xl pb-6 mt-28 font-bold tracking-wider '>
          Tools
        </h1>
        <div className='w-[30px] h-[8px] bg-[#9499ff] rounded-[10px] mx-auto'></div>
        <h2 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-xl mt-6 font-semibold tracking-wider'>
          {lang === "Eng"
            ? "Main tools I use for my projects"
            : "Strumenti principalmente utilizzati "}
        </h2>
        <div className='grid justify-center grid-cols-3 md:grid-cols-4 gap-6 lg:gap-20 mt-16'>
          {skillImg.map((skills, i) => {
            const { img, link } = skills;
            const key = i;

            return (
              <button
                key={key}
                onClick={() => {}}
                className=' flex justify-center items-center duration-500 transition-all  bg-[#161616] hover:bg-[#2c2b2b] dark:bg-gray-200 dark:hover:bg-[#ffffff] hover:scale-[.85] shadow-lg  w-[6rem] py-6 rounded-md '>
                <div className='flex flex-col justify-center items-center  max-w-[4rem] w-12'>
                  <a
                    href={link}
                    target='_blank'
                    rel='noreferrer'
                    className='w-full flex justify-center items-center'>
                    <img src={img} className='w-full' alt='' />
                  </a>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default About;
